import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@mui/material";
export const SeasonStatusChip = ({ season, size = "small", }) => {
    const getStatusConfig = (status) => {
        const statusConfig = {
            draft: { color: "warning", label: "Draft" },
            active: { color: "success", label: "Active" },
            completed: { color: "info", label: "Completed" },
            cancelled: { color: "error", label: "Cancelled" },
        };
        return (statusConfig[status] || statusConfig.draft);
    };
    if (!season.status) {
        return null;
    }
    const config = getStatusConfig(season.status);
    return _jsx(Chip, { color: config.color, label: config.label, size: size });
};
